import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-member-area-contact-dialog',
  templateUrl: './member-area-contact-dialog.component.html',
  styleUrl: './member-area-contact-dialog.component.scss',
  standalone: false,
})
export class MemberAreaContactDialogComponent {
  form = new FormGroup({
    message: new FormControl<string | null>(null, [
      Validators.required,
      Validators.maxLength(1200),
    ]),
  });

  constructor(
    private dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  get areaName(): string {
    return this.config.data?.areaName ?? 'Mitgliederbereich';
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onSend(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.dialogRef.close(this.form.value.message?.trim() ?? '');
  }
}
